export default __webpack_public_path__ + "static/media/facetime.a52e56e1.png";